import React, { useState, Suspense } from 'react';
import { Row, Col } from 'reactstrap';

const loadWidget = props => {
    switch (props.id) {
        case 'TopSearches':
            return () => import(`../../pages/dashboard/top.searches`);
        case 'PopularSearches':
            return () => import(`../../pages/dashboard/popular.searches`);
        case 'FailedUrlGraph':
            return () => import(`../../pages/dashboard/failed-url-graph`);
        case 'MapComp':
            return () => import(`../../pages/geographical-users-count/map`);
        case 'FailedUrls':
            return () => import(`../../pages/failedUrls`);
        case 'GoogleAnalytics':
            return () => import(`../../pages/dashboard/google.analytics`);
        case 'GoogleAnalyticsGraph':
            return () => import(`../../pages/dashboard/google.analytics.graph`);
        case 'SwisAnalytics':
            return () => import(`../../pages/dashboard/analytics.data`);
        case 'AdsAnalytics':
            return () => import(`../../pages/dashboard/campaignAnalytics`);
        default:
            return null;
    }
};

const DashboardWidget = (props) => {
    const [WidgetComponent] = useState(React.lazy(loadWidget(props)));
    return (
        <div>
            <Suspense fallback={<>Loading</>}>
                <Row>
                    <Col md="12" sm="12" xs="12">
                        <WidgetComponent {...props} />
                    </Col>
                </Row>
            </Suspense>
        </div >
    );
};

export default DashboardWidget;